export default "/_nuxt/54a3081e8dc516dbea8e6cecac86d206.svg";